import React, { Component } from "react";
import { Line } from "react-chartjs-2";
import firebase from "../store/firebase";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  TimeScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  Filler,
  ChartOptions,
  ChartData,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  TimeScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  Filler,
  zoomPlugin
);

class MEVPriceGraphB extends Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.state = {
      data: {
        labels: [],
        datasets: [
          {
            label: "MEV Price (USD)",
            data: [],
            borderColor: "#4bc0c0",
            backgroundColor: "rgba(75, 192, 192, 0.15)",
            fill: true,
            tension: 0.3,
            pointRadius: 2,
            pointHoverRadius: 4,
          },
        ],
      },
      isLoading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const snapshot = await firebase.database.ref("MEV").get();
      const data = snapshot.val();

      if (data) {
        const sortedData = Object.values(data).sort(
          (a, b) => new Date(a.time) - new Date(b.time)
        );

        const dateTimes = sortedData.map((entry) =>
          new Date(entry.time).toLocaleString("en-US", {
            year: "2-digit",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
        );
        const prices = sortedData.map((entry) => parseFloat(entry.price));

        this.setState({
          data: {
            labels: dateTimes,
            datasets: [
              {
                ...this.state.data.datasets[0],
                data: prices,
              },
            ],
          },
          isLoading: false,
        });
      }
    } catch (error) {
      this.setState({ error: error.message, isLoading: false });
    }
  };

  handleResetZoom = () => {
    if (this.chartRef.current) {
      this.chartRef.current.resetZoom();
    }
  };

  render() {
    const { data, isLoading, error } = this.state;

    if (isLoading) return <p>Loading graph data...</p>;
    if (error) return <p>Error loading data: {error}</p>;

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        mode: "index",
        intersect: false,
      },
      plugins: {
        legend: {
          position: "top",
          labels: {
            color: "#333",
            font: {
              size: 14,
              weight: "bold",
            },
          },
        },
        title: {
          display: true,
          text: "MEV Price Over Time With Zoom/Pan",
          color: "#222",
          font: {
            size: 18,
            weight: "bold",
          },
        },
        zoom: {
          zoom: {
            wheel: {
              enabled: true,
            },
            pinch: {
              enabled: true,
            },
            mode: "x",
          },
          pan: {
            enabled: true,
            mode: "x",
          },
          limits: {
            x: { min: 0 },
          },
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: "Date & Time",
          },
          ticks: {
            maxTicksLimit: 15,
            autoSkip: true,
          },
        },
        y: {
          title: {
            display: true,
            text: "Price (USD)",
          },
        },
      },
    };

    return (
    //   <div style={{ position: "relative", height: "400px", marginBottom: "2rem" }}>
    //     <button onClick={this.handleResetZoom} style={{ marginBottom: 2 }}>
    //       Reset Zoom
    //     </button>
    //     <Line ref={this.chartRef} data={data} options={options} />
    //   </div>
    <div style={{ position: "relative", height: "400px", marginBottom: "2rem" }}>
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
    <h2 style={{ margin: 0, fontSize: "1.2rem", fontWeight: "600" }}></h2>
    <button
      onClick={this.handleResetZoom}
      style={{
        padding: "2px 8px",
        fontSize: "0.8rem",
        borderRadius: "4px",
        border: "1px solid #ccc",
        backgroundColor: "#f2f2f2",
        cursor: "pointer",
      }}
    >
      Reset Zoom
    </button>
  </div>
  <Line ref={this.chartRef} data={data} options={options} />
</div>

    );
  }
}

export default MEVPriceGraphB;
